import { Type } from '@angular/core';
import { TerraAlertPanelComponent } from './alert/terra-alert-panel.component';
import { TerraTextInputComponent } from './forms/input/text-input/terra-text-input.component';
import { TerraColorPickerComponent } from './forms/input/color-picker/terra-color-picker.component';
import { TerraNumberInputComponent } from './forms/input/number-input/terra-number-input.component';
import { TerraButtonComponent } from './buttons/button/terra-button.component';
import { TerraCheckboxTreeComponent } from './tree/checkbox-tree/terra-checkbox-tree.component';
import { TerraCheckboxComponent } from './forms/checkbox/terra-checkbox.component';
import { TerraSelectBoxComponent } from './forms/select-box/terra-select-box.component';
import { TerraBaseToolbarComponent } from './toolbar/base-toolbar/terra-base-toolbar.component';
import { TerraPagerComponent } from './pager/terra-pager.component';
import { TerraInfoBoxComponent } from './layouts/info-box/terra-info-box.component';
import { TerraTaglistComponent } from './layouts/taglist/terra-taglist.component';
import { TerraTagComponent } from './layouts/tag/terra-tag.component';
import { TerraLoadingSpinnerComponent } from './loading-spinner/terra-loading-spinner.component';
import { TerraOverlayComponent } from './layouts/overlay/terra-overlay.component';
import { TerraDataTableComponent } from './tables/data-table/terra-data-table.component';
import { TerraDataTableContextMenuComponent } from './tables/data-table/context-menu/terra-data-table-context-menu.component';
import { TerraSimpleTableComponent } from './tables/simple/terra-simple-table.component';
import { TerraDoubleInputComponent } from './forms/input/double-input/terra-double-input.component';
import { TerraPortletComponent } from './layouts/portlet/terra-portlet.component';
import { TerraMultiCheckBoxComponent } from './forms/multi-check-box/terra-multi-check-box.component';
import { TerraSuggestionBoxComponent } from './forms/suggestion-box/terra-suggestion-box.component';
import { TerraDatePickerComponent } from './forms/input/date-picker/terra-date-picker.component';
import { TerraTextAreaInputComponent } from './forms/input/text-area-input/terra-text-area-input.component';
import { TerraCardComponent } from './layouts/card/terra-card.component';
import { TerraToggleComponent } from './buttons/toggle/terra-toggle.component';
import { TerraFileBrowserComponent } from './file-browser/terra-file-browser.component';
import { TerraFileInputComponent } from './forms/input/file-input/terra-file-input.component';
import { TerraFileChooserComponent } from './buttons/file-chooser/terra-file-chooser.component';
import { TerraNoResultNoticeComponent } from './no-result/terra-no-result-notice.component';
import { TerraButtonWithOptionsComponent } from './buttons/button-with-options/terra-button-with-options.component';
import { TerraNoteEditorComponent } from './editors/note-editor/terra-note-editor.component';
import { TerraCodeEditorComponent } from './editors/code-editor/terra-code-editor.component';
import { TerraTimePickerComponent } from './forms/input/time-picker/terra-time-picker.component';
import { TerraNodeTreeComponent } from './tree/node-tree/terra-node-tree.component';
import { TerraNodeComponent } from './tree/node-tree/node/terra-node.component';
import { TerraCategoryPickerComponent } from './data-picker/category-picker/terra-category-picker.component';
import { TerraDynamicFormComponent } from './forms/dynamic-form/terra-dynamic-form.component';
import { TerraDynamicSwitchComponent } from './forms/dynamic-form/dynamic-switch/terra-dynamic-switch.component';
import { TerraNestedDataPickerComponent } from './data-picker/nested-data-picker/terra-nested-data-picker.component';
import { TerraTwoColumnsContainerComponent } from './layouts/column-container/two-columns/terra-two-columns-container.component';
import { TerraFormComponent } from './forms/form/terra-form.component';
import {
    TerraFormContainerComponent,
    TerraFormEntryListComponent
} from './forms/form/form-container/terra-form-container--entry-list.component';
import { TerraFormEntryComponent } from './forms/form/form-entry/terra-form-entry.component';
import { TerraBreadcrumbsComponent } from './breadcrumbs/terra-breadcrumbs.component';
import { TerraTagSelectComponent } from './forms/tag-select/terra-tag-select.component';
import { TerraFileListComponent } from './file-browser/file-list/file-list.component';
import { TerraImagePreviewComponent } from './file-browser/image-preview/image-preview.component';
import { TerraThreeColumnsContainerComponent } from './layouts/column-container/three-columns/terra-three-columns-container.component';
import { TerraGroupFunctionComponent } from './tables/group-function/terra-group-function.component';
import { TerraInfoComponent } from './info/terra-info.component';
import { RadioInputComponent } from './forms/input/radio/radio-input.component';
import { RadioGroupComponent } from './forms/input/radio/radio-group.component';
import { TableRowComponent } from './tables/data-table/table-row/table-row.component';
import { FilterComponent } from './filter/filter.component';
import { TerraBaseEditorComponent } from './editors/base-editor/terra-base-editor.component';
import { TerraFormContainerWrapperComponent } from './forms/form/form-container/container-wrapper/terra-form-container-wrapper.component';
import { TableSettingsComponent } from './table/table-settings/table-settings.component';
import { TableSettingsDialogComponent } from './table/table-settings/dialog/table-settings-dialog.component';
import { SuggestionComponent } from './forms/form/form-components/suggestion/suggestion.component';
import { DoubleInputComponent } from './forms/form/form-components/double-input/double-input.component';
import { SliderComponent } from './forms/form/form-components/slider/slider.component';
import { MultiSelectComponent } from './forms/form/form-components/multi-select/multi-select.component';
import { ColorPickerComponent } from './forms/form/form-components/color-picker/color-picker.component';
import { DatePickerComponent } from './forms/form/form-components/datepicker/datepicker.component';
import { TextInputComponent } from './forms/form/form-components/text-input/text-input.component';
import { CheckboxComponent } from './forms/form/form-components/checkbox/checkbox.component';
import { SelectComponent } from './forms/form/form-components/select/select.component';
import { NumberInputComponent } from './forms/form/form-components/number-input/number-input.component';
import { TextAreaComponent } from './forms/form/form-components/text-area/text-area.component';

export const exportedComponents: Array<Type<any>> = [
    TerraAlertPanelComponent,
    TerraTextInputComponent,
    TerraColorPickerComponent,
    TerraNumberInputComponent,
    TerraButtonComponent,
    TerraCheckboxTreeComponent,
    TerraCheckboxComponent,
    TerraSelectBoxComponent,
    TerraBaseToolbarComponent,
    TerraPagerComponent,
    TerraInfoBoxComponent,
    TerraTaglistComponent,
    TerraTagComponent,
    TerraLoadingSpinnerComponent,
    TerraOverlayComponent,
    TerraDataTableComponent,
    TerraDataTableContextMenuComponent,
    TerraSimpleTableComponent,
    TerraDoubleInputComponent,
    TerraPortletComponent,
    TerraMultiCheckBoxComponent,
    TerraSuggestionBoxComponent,
    TerraDatePickerComponent,
    TerraTextAreaInputComponent,
    TerraCardComponent,
    TerraToggleComponent,
    TerraFileBrowserComponent,
    TerraFileInputComponent,
    TerraFileChooserComponent,
    TerraNoResultNoticeComponent,
    TerraButtonWithOptionsComponent,
    TerraNoteEditorComponent,
    TerraCodeEditorComponent,
    TerraTimePickerComponent,
    TerraNodeTreeComponent,
    TerraNodeComponent,
    TerraDynamicFormComponent,
    TerraDynamicSwitchComponent,
    TerraNestedDataPickerComponent,
    TerraCategoryPickerComponent,
    TerraTwoColumnsContainerComponent,
    TerraFormComponent,
    TerraFormContainerComponent,
    TerraFormEntryComponent,
    TerraFormEntryListComponent,
    TerraBreadcrumbsComponent,
    TerraTagSelectComponent,
    TerraThreeColumnsContainerComponent,
    TerraGroupFunctionComponent,
    RadioInputComponent,
    RadioGroupComponent,
    TableRowComponent,
    FilterComponent,
    TerraInfoComponent,
    TableSettingsComponent
];

export const components: Array<Type<any>> = [
    ...exportedComponents,
    TerraFileListComponent,
    TerraImagePreviewComponent,
    TerraBaseEditorComponent,
    TableSettingsDialogComponent,
    TerraFormContainerWrapperComponent,
    SuggestionComponent,
    DoubleInputComponent,
    SliderComponent,
    MultiSelectComponent,
    ColorPickerComponent,
    DatePickerComponent,
    TextInputComponent,
    CheckboxComponent,
    SelectComponent,
    NumberInputComponent,
    TextAreaComponent
];
